// Use production URL for deployed builds, localhost for dev
// Vite sets import.meta.env.MODE and import.meta.env.PROD during build
export const API_URL = import.meta.env.MODE === 'production' || import.meta.env.PROD
  ? 'https://quantum-analyzer-worker.sparsesupernova.workers.dev'
  : 'http://localhost:8787';

